import { render } from "./LectureViewReport.vue?vue&type=template&id=6a5481da&scoped=true"
import script from "./LectureViewReport.vue?vue&type=script&lang=js"
export * from "./LectureViewReport.vue?vue&type=script&lang=js"

import "./LectureViewReport.vue?vue&type=style&index=0&id=6a5481da&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5481da"]])

export default __exports__